var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"label checkbox is-unselectable",class:_vm.className},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled,"name":_vm.name},domProps:{"checked":_vm.value},on:{"change":_vm.onChange}}),_c('div',{staticClass:"checkmark",class:_vm.classMarkName}),_c('span',[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }